import { render } from "./QueryAlert.vue?vue&type=template&id=22b30a40"
import script from "./QueryAlert.vue?vue&type=script&lang=js"
export * from "./QueryAlert.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__